// extracted by mini-css-extract-plugin
export var wordContainer = "_pn-0";